import { PageHeader } from 'antd'
import { useTranslation } from 'react-i18next'

import { Line } from '@/components/pages/ClientDevice/styles'

const ClientDeviceByDayHeader = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageHeader
        style={{ padding: 0 }}
        ghost={false}
        title={t('components.pages.clientDevice.listReport.pageHeader.title')}
      />
      <Line />
    </>
  )
}

ClientDeviceByDayHeader.displayName = 'ClientDeviceByDayHeader'
export default ClientDeviceByDayHeader
